// extracted by mini-css-extract-plugin
export default {"varSpDown1":"0.75rem","varSpDown4":"0.125rem","quickResponderBadge":"quickResponderBadge--8fc8d","quickResponderBadgeText":"quickResponderBadgeText--5a8e9"};